import { render, staticRenderFns } from "./face-photo.vue?vue&type=template&id=614749ff&"
import script from "./face-photo.vue?vue&type=script&lang=js&"
export * from "./face-photo.vue?vue&type=script&lang=js&"
import style0 from "./face-photo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports